<template>
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      :style="iconStyle" viewBox="0 0 125.000000 125.000000"
      class='fill-current'
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,125.000000) scale(0.100000,-0.100000)" stroke="none">
        <path d="M525 1216 c-54 -24 -100 -71 -122 -123 -7 -19 -13 -69 -13 -122 0
        -50 -5 -102 -12 -116 -10 -21 -9 -29 5 -43 14 -13 21 -14 35 -6 15 10 17 26
        13 126 -3 101 -1 120 18 156 41 81 130 123 216 101 61 -15 118 -72 133 -132
        15 -59 15 -169 0 -202 -9 -21 -9 -29 4 -41 10 -10 24 -14 36 -10 19 6 20 13
        16 104 -7 148 -13 176 -43 223 -20 32 -45 54 -88 77 -73 39 -126 41 -198 8z"/>
        <path d="M154 951 c-2 -2 -4 -215 -4 -473 l0 -468 449 0 c247 0 456 3 465 6
        14 5 16 59 16 470 l0 464 -101 0 -101 0 5 -37 c3 -21 8 -49 12 -63 16 -61 -70
        -105 -116 -59 -18 18 -19 28 -13 90 l7 69 -147 0 c-80 0 -149 -1 -153 -2 -9
        -3 -8 -62 2 -98 16 -61 -70 -105 -116 -59 -18 18 -19 28 -13 89 l6 69 -97 3
        c-53 2 -99 1 -101 -1z"/>
      </g>
    </svg>
</template>

<script>
export default {
  name: 'ShoppingCartSvg',
  components: {
  },
  props: {
    width: {
      type: [Number, String],
      default: 25
    },
    height: {
      type: [Number, String],
      default: 25
    }
  },
  computed: {
    iconStyle() {
      const { width, height } = this;
      return {
        width: `${width}px`,
        height: `${height}px`
      };
    }
  }
};
</script>
